import { useCallback } from "react";

import { useAppDispatch } from "Store/hooks";

import {
  saveSetupOptionsConfig as saveSetupOptionsConfigAction,
  SetupOptionsConfig
} from "../setupOptions.slice";

export const useSaveSetupOptionsConfig = () => {
  const dispatch = useAppDispatch();

  const saveSetupOptionsConfig = useCallback(
    (setupOptionsConfig: SetupOptionsConfig) => {
      dispatch(saveSetupOptionsConfigAction(setupOptionsConfig));
    },
    [dispatch]
  );

  return saveSetupOptionsConfig;
};
